import React from "react";
import { Topbar } from "./topbar/Topbar";
import { CatalogueNavbar } from "./navbar";
import { CatalogueSection } from "./catalogueSection";
import { usePortalCatalogueParams } from "../hooks/usePortalCatalogueParams";
import { usePortalCart } from "../hooks/usePortalCart";
import { message } from "antd";
import { useGetPortalCustomerCatalogueQuery } from "../../../store/apiSlice/portalCatalogueApiSlice";

export const CataloguePage = () => {
  const {
    searchValue,
    activeCategoryId,
    page,
    pageSize,
    queryParams,
    setSearchValue,
    setCategoryId,
    setPage,
    setPageSize,
  } = usePortalCatalogueParams({ defaultPageSize: 10 });

  const { data: catalogueData, isLoading } = useGetPortalCustomerCatalogueQuery(queryParams);
  const { itemCount, total, addItem, addingProductId } = usePortalCart();

  const handleAddToCart = async (productId, quantity) => {
    const result = await addItem(productId, quantity);
    if (result.success) {
      message.success("Product added to cart!");
      return true;
    } else {
      message.error(result.error);
      return false;
    }
  };

  const handlePaginationChange = (newPage, newPageSize) => {
    setPage(newPage);
    if (newPageSize !== pageSize) {
      setPageSize(newPageSize);
    }
  };

  return (
    <>
      <Topbar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        cartItemCount={itemCount}
        cartTotal={total}
      />
      <CatalogueNavbar activeCategoryId={activeCategoryId} onCategoryChange={setCategoryId} />
      <CatalogueSection
        products={catalogueData?.results || []}
        count={catalogueData?.count || 0}
        isLoading={isLoading && !catalogueData}
        page={page}
        pageSize={pageSize}
        onPaginationChange={handlePaginationChange}
        onAddToCart={handleAddToCart}
        addingProductId={addingProductId}
      />
    </>
  );
};
